import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

const SETTINGS_DOC = doc(db, 'settings', 'app');

/** Load persisted app settings (categories, payment modes). Returns null on error. */
export async function loadAppSettings() {
  try {
    const snap = await getDoc(SETTINGS_DOC);
    if (!snap.exists()) return null;
    return snap.data();
  } catch {
    return null;
  }
}

/** Persist categories to Firestore. */
export async function saveCategories(categories) {
  await setDoc(SETTINGS_DOC, { categories, updatedAt: serverTimestamp() }, { merge: true });
}

/** Persist payment modes to Firestore. */
export async function savePaymentModes(paymentModes) {
  await setDoc(SETTINGS_DOC, { paymentModes, updatedAt: serverTimestamp() }, { merge: true });
}

/** Persist planned labels to Firestore. */
export async function savePlannedLabels(plannedLabels) {
  await setDoc(SETTINGS_DOC, { plannedLabels, updatedAt: serverTimestamp() }, { merge: true });
}
